import { List } from 'antd'

const UngroupedListItem: React.FC<
  Required<Pick<React.CSSProperties, 'paddingLeft'>>
> = ({ children, paddingLeft }) => (
  <List.Item
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      /**
       * this feels very hacky, but it's what we need to do in order
       * to get ungrouped list items to "match" up with the cims collapse
       * component above
       */
      paddingTop: 12,
      paddingBottom: 12,
      paddingRight: 32,
      paddingLeft,
    }}
  >
    {children}
  </List.Item>
)

export default UngroupedListItem
